import { render } from "./SettingsAccountingCharts.vue?vue&type=template&id=ffaf4078"
import script from "./SettingsAccountingCharts.vue?vue&type=script&lang=js"
export * from "./SettingsAccountingCharts.vue?vue&type=script&lang=js"

import "./SettingsAccountingCharts.vue?vue&type=style&index=0&id=ffaf4078&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__